import { cn } from "@/lib/utils";

interface StrippenkaartVisualProps {
  resterende: number;
  totaal: number;
  className?: string;
}

export function StrippenkaartVisual({ resterende, totaal, className }: StrippenkaartVisualProps) {
  return (
    <div className={cn("flex gap-1.5", className)}>
      {Array.from({ length: totaal }).map((_, index) => {
        const isAvailable = index < resterende;
        return (
          <div
            key={index}
            className={cn(
              "h-6 flex-1 rounded-md transition-all duration-200 border",
              isAvailable 
                ? "bg-primary/90 border-primary shadow-sm hover:bg-primary" 
                : "bg-gray-100 border-gray-200 opacity-50"
            )}
            title={isAvailable ? "Beschikbaar" : "Gebruikt"}
          />
        );
      })}
    </div>
  );
}

